import React, { useEffect, useState } from 'react';
import { useProject } from '../contexts/ProjectContext';
import ProjectOverview from '../components/projects/ProjectOverview';
import ModuleGrid from '../components/modules/ModuleGrid';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const {FiAlertTriangle} = FiIcons;

const DashboardPage = () => {
  const { fetchProjects, modules, projects, isLoading } = useProject();
  const [pageError, setPageError] = useState(null);
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    const initializeDashboard = async () => {
      try {
        setPageError(null);
        await fetchProjects();
        setIsInitialized(true);
      } catch (error) {
        console.error('Dashboard initialization error:', error);
        setPageError(error.message || 'Failed to load dashboard');
        setIsInitialized(true);
      }
    };

    initializeDashboard();
  }, [fetchProjects]);

  if (!isInitialized) {
    return (
      <div className="min-h-screen bg-slate-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p className="text-slate-600">Loading dashboard…</p>
        </div>
      </div>
    );
  }

  if (pageError) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-slate-50">
        <div className="max-w-lg bg-white border border-red-200 text-red-800 p-6 rounded shadow-sm">
          <div className="flex items-center mb-4">
            <SafeIcon icon={FiAlertTriangle} className="w-5 h-5 mr-2" />
            <h1 className="font-semibold">Unable to load dashboard</h1>
          </div>
          <p className="mb-2">Error: {pageError}</p>
          <p className="text-sm text-slate-600 mb-4">
            Check your API routes and environment variables for /api/projects and /api/modules.
          </p>
          <button
            onClick={() => window.location.reload()}
            className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors"
          >
            Retry
          </button>
        </div>
      </div>
    );
  }

  // Always render a shell UI even if data is empty
  return (
    <div className="min-h-screen bg-slate-50">
      <header className="bg-white border-b border-slate-200 sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center">
              <div className="w-8 h-8 bg-blue-600 rounded-lg flex items-center justify-center mr-3">
                <span className="text-white font-bold text-sm">G</span>
              </div>
              <div>
                <h1 className="text-xl font-semibold text-slate-900">GYSO Dashboard</h1>
                <p className="text-xs text-slate-500">Build & manage all your apps</p>
              </div>
            </div>
          </div>
        </div>
      </header>

      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="space-y-8">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            <div className="lg:col-span-1">
              <ProjectOverview />
            </div>
            <div className="lg:col-span-2">
              <ModuleGrid />
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default DashboardPage;